
import { defineComponent, PropType } from 'vue';
import ModalComment from '@/feedback/components/ModalComment.vue';
import { mdiClose } from '@mdi/js';


import BaseProduct from './BaseProduct.vue';
import { PRODUCT_TYPE } from '../constants';
import { Product } from '../interfaces';

export default defineComponent({
  name: 'ModalProduct',

  components: {
    ModalComment
  },

  extends: BaseProduct,

  props: {
    product: {
      type: Object as PropType<Product>,
      required: true
    },

    isActivatedComment: {
      type: Boolean,
      required: true
    }
  },

  setup() {
    const typeProduct = PRODUCT_TYPE;

    const svgIcons = {
      close: mdiClose
    };

    return {
      typeProduct,
      svgIcons
    };
  },

  computed: {
    enableFeedback(): boolean {
      return this.$store.getters['site/enableFeedback'];
    }
  }
});
